var _rect, _path, _rect2, _circle, _circle2, _circle3, _rect3, _path2, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiChatHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    width: 42,
    height: 54,
    rx: 3,
    stroke: "#274642",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 39H61.5L63 38V26.2903V19.5L62 15.5H42H22L21 18.6129V34.871V39H42.5L51 42.5L52.5 39Z",
    fill: "#E3EDC3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 10.1149,
    rx: 4.36364,
    transform: "matrix(-1 0 0 1 49 24.7009)",
    fill: "#274642"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83908,
    cy: 1.83908,
    r: 1.83908,
    transform: "matrix(-1 0 0 1 45.873 27.8276)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83908,
    cy: 1.83908,
    r: 1.83908,
    transform: "matrix(-1 0 0 1 39.9883 27.8276)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.83908,
    cy: 1.83908,
    r: 1.83908,
    transform: "matrix(-1 0 0 1 42.9316 19)",
    fill: "#274642"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.47126,
    height: 2.75862,
    transform: "matrix(-1 0 0 1 41.8281 21.9424)",
    fill: "#274642"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39H43.2765C43.4237 39 43.5691 39.0325 43.7023 39.0952L50.3566 42.2267C51.0696 42.5622 51.8725 41.9797 51.7747 41.1978L51.6405 40.124C51.5659 39.5272 52.0313 39 52.6328 39H63",
    stroke: "#274642",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23852_6203",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 43,
    width: 24,
    height: 24
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 43,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23852_6203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 64C39.9 64 38.0417 63.3625 36.425 62.0875C34.8083 60.8125 33.7583 59.1833 33.275 57.2C33.2083 56.95 33.2583 56.7208 33.425 56.5125C33.5917 56.3042 33.8167 56.1833 34.1 56.15C34.3667 56.1167 34.6083 56.1667 34.825 56.3C35.0417 56.4333 35.1917 56.6333 35.275 56.9C35.675 58.4 36.5 59.625 37.75 60.575C39 61.525 40.4167 62 42 62C43.95 62 45.6042 61.3208 46.9625 59.9625C48.3208 58.6042 49 56.95 49 55C49 53.05 48.3208 51.3958 46.9625 50.0375C45.6042 48.6792 43.95 48 42 48C40.85 48 39.775 48.2667 38.775 48.8C37.775 49.3333 36.9333 50.0667 36.25 51H38C38.2833 51 38.5208 51.0958 38.7125 51.2875C38.9042 51.4792 39 51.7167 39 52C39 52.2833 38.9042 52.5208 38.7125 52.7125C38.5208 52.9042 38.2833 53 38 53H34C33.7167 53 33.4792 52.9042 33.2875 52.7125C33.0958 52.5208 33 52.2833 33 52V48C33 47.7167 33.0958 47.4792 33.2875 47.2875C33.4792 47.0958 33.7167 47 34 47C34.2833 47 34.5208 47.0958 34.7125 47.2875C34.9042 47.4792 35 47.7167 35 48V49.35C35.85 48.2833 36.8875 47.4583 38.1125 46.875C39.3375 46.2917 40.6333 46 42 46C43.25 46 44.4208 46.2375 45.5125 46.7125C46.6042 47.1875 47.5542 47.8292 48.3625 48.6375C49.1708 49.4458 49.8125 50.3958 50.2875 51.4875C50.7625 52.5792 51 53.75 51 55C51 56.25 50.7625 57.4208 50.2875 58.5125C49.8125 59.6042 49.1708 60.5542 48.3625 61.3625C47.5542 62.1708 46.6042 62.8125 45.5125 63.2875C44.4208 63.7625 43.25 64 42 64ZM43 54.6L45.5 57.1C45.6833 57.2833 45.775 57.5167 45.775 57.8C45.775 58.0833 45.6833 58.3167 45.5 58.5C45.3167 58.6833 45.0833 58.775 44.8 58.775C44.5167 58.775 44.2833 58.6833 44.1 58.5L41.3 55.7C41.2 55.6 41.125 55.4875 41.075 55.3625C41.025 55.2375 41 55.1083 41 54.975V51C41 50.7167 41.0958 50.4792 41.2875 50.2875C41.4792 50.0958 41.7167 50 42 50C42.2833 50 42.5208 50.0958 42.7125 50.2875C42.9042 50.4792 43 50.7167 43 51V54.6Z",
    fill: "#274642"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChatHistory);
export default __webpack_public_path__ + "static/media/ai-chat-history.4813dfd4ed59167b22112f9f903c98f8.svg";
export { ForwardRef as ReactComponent };